import { useEffect, useState } from "react";
import { PlusSquareOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Switch,
  Typography,
  message,
} from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { addService, updateService } from "../../../network/service";
// import { ListTaxesAndGroups, getAllTaxes } from "../../../network/tax";
import { Durations } from "../../../enum/pricingDuration";
import DeleteSVG from "../../../assets/common/DeleteSVG";
import { queryKeys } from "../../../services/react-query/queryKeys";
import queryClient from "../../../services/react-query/queryClient";
import IconSVG from "../../../assets/teamMember/IconSVG";
import VectorSVG from "../../../assets/common/VectorSVG";
import { TreeNode } from "antd/es/tree-select";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

interface PriceOptionProps {
  onClose: () => void;
  serviceInfo: any;
  setServiceInfo: React.Dispatch<React.SetStateAction<{}>>;
}

function PriceOption({
  onClose,
  serviceInfo,
  setServiceInfo,
}: PriceOptionProps) {
  // const [selectedTaxableId, setSelectedTaxableId] = useState(null);
  const [selectedPricingData, setSelectedPricingData] = useState<any[]>(
    serviceInfo?.pricing_options?.length ? serviceInfo?.pricing_options : []
  );

  const serviceTeamMember = serviceInfo?.teamMember;

  const [form] = Form.useForm();

  // const { data: ListTaxesAndGroup } = useQuery(
  //   [queryKeys.listTaxesAndGroup],
  //   () => ListTaxesAndGroups()
  // );
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number } }) => state.calendar
  );
  console.log(serviceInfo, "serviceInfo");
  useEffect(() => {
    if (serviceInfo?.id) {
      const selectedPricing = serviceInfo?.pricing_options.map((item: any) => {
        const { name, ...rest } = item;
        return rest;
      });
      setSelectedPricingData(selectedPricing);
      form.setFieldValue("pricing", [{}]);
    }
  }, [serviceInfo?.id]);

  const { mutate: onAddService, isLoading } = useMutation(
    (body) => addService(body, locationId),
    {
      onSuccess: (res: any) => {
        if (res?.response?.status === 422 || res?.response?.status === 500) {
          message.error(res?.response?.data?.message);
        } else {
          message.success(
            intl.formatMessage({ id: "success_add_service_message" })
          );
          queryClient.invalidateQueries([queryKeys.listCategories]);
          queryClient.invalidateQueries([queryKeys.listServices]);
          setServiceInfo({});
          onClose();
        }
      },
      onError: (error) => {
        message.error(intl.formatMessage({ id: "error_add_service_message" }));
      },
    }
  );

  const { mutate: onUpdateService, isLoading: editLoading } = useMutation(
    (body) => updateService(body, locationId, serviceInfo?.id),
    {
      onSuccess: (res: any) => {
        if (res?.response?.status === 422 || res?.response?.status === 500) {
          message.error(res?.response?.data?.message);
        } else {
          queryClient.invalidateQueries([queryKeys.listCategories]);
          queryClient.invalidateQueries([queryKeys.listServices]);
          message.success("تم تعديل الخدمة بنجاح");
          setServiceInfo({});
          onClose();
        }
      },
      onError: (error) => {
        console.log("Add Category error:", error);
        message.error("حاول مرة اخرى");
      },
    }
  );

  const handleRemovePricing = (indexToRemove: number) => {
    const newPricingData = selectedPricingData.filter(
      (_: any, index: number) => index !== indexToRemove
    );
    setSelectedPricingData(newPricingData);
    setServiceInfo({ ...serviceInfo, pricing_options: newPricingData });
  };
  const onFinish = async (values: any) => {
    if (!selectedPricingData.length) {
      message.error("يجب تحديد السعر والمدة الزمنية");
      return;
    }
    const { pricing, ...otherValues } = values;
    const newServiceData = {
      ...serviceInfo,
      ...otherValues,
      ...serviceTeamMember,
      enable_extra_time_feature: serviceInfo?.enable_extra_time_feature,
      enable_team_member_commission: serviceInfo?.enable_team_member_commission
        ? 1
        : 0,
      pricing: selectedPricingData,
      enable_online_booking: true,
      auto_add_to_new_sale: 1,
      is_available: 1,
      team_member_ids: serviceInfo?.team_members,
    };
    if (serviceInfo?.id) {
      newServiceData.id = serviceInfo?.id;
      onUpdateService(newServiceData);
    } else {
      onAddService(newServiceData);
    }
  };

  // const taxData = ListTaxesAndGroup?.data;
  const intl = useIntl();
  const generateTaxTreeNodes = (taxes: any[]) => {
    return taxes?.map((tax) => (
      <TreeNode
        value={`taxChil_${tax?.id}`}
        title={`${tax?.name.ar} (${tax?.tax_rate})`}
        key={`taxChil_${tax?.id}`}
        disabled
      />
    ));
  };
  const PricingOptions: { value: string; label: string }[] = [
    { value: "free", label: intl.formatMessage({ id: "intl.form.free" }) },
    { value: "from", label: intl.formatMessage({ id: "intl.form.from" }) },
    { value: "fixed", label: intl.formatMessage({ id: "intl.form.fixed" }) },
  ];
  const generateGroupNode = (group: {
    id: any;
    name: { ar: any };
    taxes: any[];
  }) => (
    <TreeNode
      value={`group_${group?.id}`}
      title={group?.name.ar}
      key={`group_${group?.id}`}
    >
      {generateTaxTreeNodes(group.taxes)}
    </TreeNode>
  );

  // const generateTaxTree = () => {
  //   return taxData?.map(
  //     (item: { taxes: any; id: any; name: any; tax_rate?: any }) => {
  //       if (item?.taxes && item?.taxes?.length > 0) {
  //         return generateGroupNode(item);
  //       } else {
  //         return (
  //           <TreeNode
  //             value={`tax_${item?.id}`}
  //             title={`${item?.name.ar} (${item?.tax_rate})`}
  //             key={`tax_${item?.id}`}
  //           />
  //         );
  //       }
  //     }
  //   );
  // };

  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  return (
    <Form
      onFinish={onFinish}
      onValuesChange={(changedValues: any, values: any) => {
        setServiceInfo({
          ...serviceInfo,
          ...changedValues,
        });
      }}
      autoComplete="off"
      layout="vertical"
      className="w-full"
      form={form}
      initialValues={{
        enable_online_booking: false,
        pricing: [{}],
        enable_extra_time_feature:
          serviceInfo?.enable_extra_time_feature || false,
      }}
    >
      <Form.List name="pricing">
        {(fields, { add, remove }) => (
          <>
            <Form.Item className="p-2 rounded bg-color-light-gr w-full text-color-primary">
              <Row className="mb-4">
                <Col
                  className="gutter-row"
                  xl={24}
                  lg={8}
                  xs={24}
                  sm={24}
                  span={11}
                >
                  <label className="text-color-primary">
                    {intl.formatMessage({ id: "pricing" })}
                  </label>
                </Col>
              </Row>
              {fields.map(({ key, name, ...restField }, index) => (
                <Row key={key} gutter={{ xs: 8, sm: 16, md: 24, lg: 15 }}>
                  <Col
                    className="gutter-row"
                    xl={8}
                    lg={12}
                    xs={24}
                    sm={12}
                    span={12}
                  >
                    <Form.Item
                      {...restField}
                      required={false}
                      name={[name, "duration"]}
                      label={intl.formatMessage({
                        id: "service_duration_label",
                      })}
                    >
                      <Select
                        showSearch
                        filterOption={filterOption}
                        placeholder={intl.formatMessage({
                          id: "service_duration_placeholder",
                        })}
                        className="w-full my-input"
                        options={Durations?.map((item) => ({
                          value: item,
                          label: item,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="gutter-row"
                    xl={8}
                    lg={12}
                    xs={24}
                    sm={12}
                    span={12}
                  >
                    <Form.Item
                      {...restField}
                      required={false}
                      name={[name, "price_type"]}
                      label={intl.formatMessage({
                        id: "service_pricing_type_label",
                      })}
                    >
                      <Select
                        showSearch
                        filterOption={filterOption}
                        placeholder={intl.formatMessage({
                          id: "service_pricing_type_placeholder",
                        })}
                        className="w-full my-input"
                        options={PricingOptions.map((item) => ({
                          value: item.value,
                          label: item.label,
                        }))}
                      />
                    </Form.Item>
                  </Col>

                  <Col
                    className="gutter-row"
                    xl={7}
                    lg={12}
                    xs={24}
                    sm={12}
                    span={12}
                  >
                    <Form.Item shouldUpdate>
                      {() => (
                        <Typography>
                          {form.getFieldValue([
                            "pricing",
                            index,
                            "price_type",
                          ]) === "free" ? (
                            <Form.Item
                              {...restField}
                              required={false}
                              name={[name, "price"]}
                              label={intl.formatMessage({
                                id: "final_price_label",
                              })}
                              rules={[
                                {
                                  validator(rule, value, callback) {
                                    if (value && +value < 1) {
                                      return Promise.reject(
                                        intl.formatMessage({
                                          id: "regular_price_validation_message",
                                        })
                                      );
                                    } else {
                                      return Promise.resolve();
                                    }
                                  },
                                },
                              ]}
                            >
                              <Input
                                type="number"
                                min={1}
                                placeholder={intl.formatMessage({
                                  id: "final_price_placeholder",
                                })}
                                className="w-full my-input"
                              />
                            </Form.Item>
                          ) : (
                            <Form.Item
                              {...restField}
                              required={false}
                              name={[name, "price"]}
                              // rules={[
                              //   // {
                              //   //   required: true,
                              //   //   message: 'ادخل السعر النهائي',
                              //   // },
                              //   {
                              //     validator(rule, value, callback) {
                              //       console.log(value, "valueeeeee");
                              //       if (value <= 0) {
                              //         return Promise.reject(
                              //           "يجب أن تكون القيمة أكبر من 0"
                              //         );
                              //       } else {
                              //         return Promise.resolve();
                              //       }
                              //     },
                              //   },
                              // ]}
                              rules={[
                                {
                                  validator(rule, value, callback) {
                                    if (value && +value < 1) {
                                      return Promise.reject(
                                        intl.formatMessage({
                                          id: "regular_price_validation_message",
                                        })
                                      );
                                    }
                                    // else if (value) {
                                    //   const existedPrice =
                                    //     selectedPricingData?.find(
                                    //       (item: {
                                    //         id: number;
                                    //         price: string;
                                    //         duration: string;
                                    //       }) => {
                                    //         return +item?.price === +value;
                                    //       }
                                    //     );
                                    //   if (existedPrice) {
                                    //     return Promise.reject(
                                    //       "السعر النهائي موجود بالفعل"
                                    //     );
                                    //   }
                                    // }
                                    else {
                                      return Promise.resolve();
                                    }
                                  },
                                },
                              ]}
                              label={intl.formatMessage({
                                id: "final_price_label",
                              })}
                            >
                              <Input
                                type="number"
                                min={1}
                                placeholder={intl.formatMessage({
                                  id: "final_price_placeholder",
                                })}
                                className="w-full my-input"
                              />
                            </Form.Item>
                          )}
                        </Typography>
                      )}
                    </Form.Item>
                  </Col>

                  <Col
                    className="gutter-row"
                    xl={1}
                    lg={12}
                    xs={24}
                    sm={12}
                    span={12}
                  >
                    <Form.Item label=" ">
                      <Button
                        className="border-none bg-transparent shadow-none outline-none"
                        onClick={() => {
                          const pricingData = form.getFieldValue([
                            "pricing",
                            index,
                          ]);
                          console.log(
                            pricingData,
                            "pricingDatapricingDatapricingDatapricingData"
                          );
                          // form.setFields([
                          //   {
                          //     name: ['pricing', index],
                          //     errors: ['error-string'],
                          //   },
                          // ]);
                          if (!pricingData?.duration) {
                            message?.error(
                              intl.formatMessage({
                                id: "service_duration_error",
                              })
                            );
                            return false;
                          }
                          if (!pricingData?.price_type) {
                            message?.error(
                              intl.formatMessage({ id: "pricing_type_error" })
                            );
                            return false;
                          }
                          if (
                            pricingData?.price_type !== "free" &&
                            !pricingData?.price
                          ) {
                            message?.error(
                              intl.formatMessage({ id: "price_required_error" })
                            );
                            return false;
                          }
                          if (
                            pricingData?.price_type !== "free" &&
                            +pricingData?.price <= 0
                          ) {
                            message?.error(
                              intl.formatMessage({
                                id: "price_greater_than_zero_error",
                              })
                            );
                            return false;
                          }
                          if (!pricingData) return;

                          const existedPrice = selectedPricingData?.find(
                            (item: {
                              id: number;
                              price: string;
                              duration: string;
                            }) => {
                              console.log(item, pricingData);
                              if (pricingData?.price_type === "free") {
                                return (
                                  0 === +pricingData?.price ||
                                  (!pricingData?.price &&
                                    +item?.duration === +pricingData?.duration)
                                );
                              }
                              return (
                                +item?.price === +pricingData?.price &&
                                +item?.duration === +pricingData?.duration
                              );
                            }
                          );
                          if (existedPrice) {
                            message?.error(
                              intl.formatMessage({
                                id: "price_already_exists_error",
                              })
                            );
                            return false;
                          }
                          const newPricingOptions = [
                            ...selectedPricingData,
                            {
                              ...pricingData,
                              price:
                                pricingData?.price_type === "free"
                                  ? 0
                                  : pricingData?.price
                                  ? pricingData?.price
                                  : 0,
                            },
                          ];
                          setSelectedPricingData(newPricingOptions);
                          setServiceInfo({
                            ...serviceInfo,
                            pricing_options: newPricingOptions,
                          });

                          form.resetFields();
                        }}
                        block
                        icon={
                          <PlusOutlined className="bg-[#00086D] text-white p-1 rounded-md" />
                        }
                      ></Button>
                    </Form.Item>
                  </Col>
                </Row>
              ))}
              {selectedPricingData.map((pricingData, index) => (
                <div
                  key={index}
                  className="flex my-1  bg-white p-1 justify-between rounded"
                >
                  <div className="flex items-center">
                    <div className="flex gap-1 items-center">
                      <span>
                        <IconSVG />
                      </span>
                      <span className="mr-2">{pricingData?.duration}</span>
                      <small className="text-xs self-center mt-2">
                        {intl.formatMessage({ id: "minutes" })}
                      </small>
                    </div>
                    <div className="mx-4">
                      <VectorSVG />
                    </div>
                    <div className="flex gap-1 items-center">
                      <span>
                        {intl.formatMessage({
                          id: `intl.form.${pricingData?.price_type}`,
                        })}
                      </span>
                    </div>
                    <div className="mx-4">
                      <VectorSVG />
                    </div>
                    <div className="flex gap-1 items-center">
                      <span>{pricingData?.price || 0}</span>
                      <small className="text-xs self-center mt-2">
                        {intl.formatMessage({ id: "saudi_riyal" })}
                      </small>
                    </div>
                  </div>

                  <Button
                    type="text"
                    htmlType="button"
                    onClick={() => handleRemovePricing(index)}
                  >
                    <DeleteSVG />
                  </Button>
                </div>
              ))}
            </Form.Item>
          </>
        )}
      </Form.List>

      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify={"space-between"}
        className="items-baseline "
      >
        <Col className="gutter-row">
          <label className="text-base  mt-3 w-full">
            {intl.formatMessage({ id: "activate_extra_time" })}
          </label>
        </Col>
        <Col className="gutter-row">
          <Form.Item name={"enable_extra_time_feature"}>
            <Switch />
          </Form.Item>
        </Col>
      </Row>

      {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify={"space-between"}>
        <Col className="gutter-row">
          <label className="text-base font-semibold w-full">
            {intl.formatMessage({ id: "vat" })}
          </label>
        </Col>
         <Col className="gutter-row">
          <Form.Item name={"taxable_type"} required={false} className="hidden">
            <Input />
          </Form.Item>
          <Form.Item name="taxable_id" className="w-full">
            <TreeSelect
              placeholder={intl.formatMessage({ id: "select_tax_type" })}
              onChange={(value) => {
                const taxableType = value.startsWith("group_")
                  ? "tax_group"
                  : "tax";
                form.setFieldsValue({ taxable_type: taxableType });
                setSelectedTaxableId(
                  value.replace("group_", "").replace("tax_", "")
                ); // Extract the ID
              }}
            >
              {generateTaxTree()}
            </TreeSelect>
          </Form.Item>
        </Col> 
      </Row> */}

      <Flex gap="middle" align="center" justify="center">
        <Button
          type="primary"
          loading={isLoading || editLoading}
          block
          htmlType="submit"
        >
          {serviceInfo?.id
            ? intl.formatMessage({ id: "edit_service_button" })
            : intl.formatMessage({ id: "add_service_button" })}
        </Button>
        <Button
          type="primary"
          disabled={isLoading}
          block
          onClick={onClose}
          className="btn-primary-light"
          htmlType="button"
        >
          {intl.formatMessage({ id: "cancel_button" })}
        </Button>
      </Flex>
    </Form>
  );
}

export default PriceOption;
